import { Sparkles } from "lucide-react";
import { scrollToSection } from "../lib/scroll";

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-white/10 pt-20 pb-10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 bg-[#00F0FF] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-[#0C1B24]" />
          </span>
          <p className="font-mukta text-slate-400 text-sm">
            व्यावसायिक एवं कॉर्पोरेट सफाई समाधान — मुज़फ्फरनगर (उ.प्र.)
          </p>
        </div>
        <button
          data-testid="footer-book-btn"
          onClick={() => scrollToSection("#booking")}
          className="self-start md:self-auto font-spacemono text-xs tracking-[0.25em] text-[#00F0FF] uppercase hover:text-white transition-colors"
        >
          Enquiry करें →
        </button>
      </div>
      <p
        data-testid="footer-brand"
        className="mt-14 font-spacemono font-bold text-[13.5vw] leading-none text-outline whitespace-nowrap select-none"
      >
        SUPER CLEANER
      </p>
      <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mukta text-xs text-slate-500">
          © {new Date().getFullYear()} Super Cleaner Services — एक रजिस्टर्ड फर्म
        </p>
        <div className="flex items-center gap-6">
          <a
            data-testid="footer-admin-link"
            href="/admin"
            className="font-spacemono text-[10px] tracking-[0.3em] text-slate-600 uppercase hover:text-[#00F0FF] transition-colors"
          >
            Admin
          </a>
          <p className="font-spacemono text-[10px] tracking-[0.3em] text-slate-600 uppercase">
            Clean Spaces · Clear Mind
          </p>
        </div>
      </div>
    </div>
  </footer>
);
